// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller";

const CONF = {
  noResults:
    "<li>" + "<h3> Es wurden keine Suchergebnisse gefunden. </h3>" + "</li>",
  errorMsg:
    "<li>" +
    "<h3> Es ist ein Fehler aufgetreten. Es konnten keine Suchergebnisse gefunden werden. </h3>" +
    "</li>",
};

export default class JobListingController extends AdvancedController {
  static targets = ["searchInput", "locationInput", "list", "listItem"];

  static values = {
    locationIcon: { type: String, default: '' },
    positionIcon: { type: String, default: '' },
  };

  connect() {
    this.locationIcon = atob(this.locationIconValue);
    this.positionIcon = atob(this.positionIconValue);
    super.connect(...arguments)
  }

  onSearch(e) {
    this.searchFunction(e);
  }

  reset(e) {
    this.searchInputTarget.value = "";
    this.locationInputTarget.value = " ";
    this.searchFunction(e);
  }

  async searchFunction(e) {
    var city, term;
    e.preventDefault();

    term = this.searchInputTarget.value.trim();
    city = this.locationInputTarget.value.trim();

    const formData = new FormData();

    formData.append("action", "job_offers_search");

    if (term != "") {
      formData.append("term", term);
    }
    if (city != "") {
      formData.append("city", city);
    }

    try {
      const response = await fetch(ajax.url, {
        method: "POST",
        body: formData,
      });
      const json = await response.json();

      this.listTarget.innerHTML = "";

      let jobHtml = "";
      if (json.length > 0) {
        for (const job of json) {
          jobHtml += this.renderListItem(job);
        }
        this.listTarget.innerHTML = jobHtml;
      } else {
        this.renderNoResults();
      }
    } catch (error) {
      this.renderError();
    }
  }

  renderError() {
    this.listTarget.innerHTML = CONF.errorMsg;
  }

  renderNoResults() {
    this.listTarget.innerHTML = CONF.noResults;
  }

  renderListItem(job) {
    const topData = `
                <div class="card jobs__overview__job">
              <div class="jobs__overview__meta">`;

    let locationData = '';
    if (job.location) {
      locationData = `<div class="jobs__overview__location">
${this.locationIcon}
  ${job.location}
</div>`
    };

    let positionData = '';
    if (job.position) {
      positionData = `<div class="jobs__overview__position">
  ${this.positionIcon}
  ${job.position}
</div>`
    };







    const bottomData = `
              </div>
              <h3>
              ${job.title}
              </h3>
              <p>
              ${job.excerpt}
              </p>
              <p>
                <a class="btn btn--primary btn--inverted" href="${job.permalink}">
                 Weitere Informationen
                </a>
              </p>
            </div>
      `;

    const data = topData + locationData + positionData + bottomData;
    console.log(data);
    return data;
  }
}
